import api from "./api";

async function getOpenBankingRefund(id) {
  try {
    const response = await api.get("api/openbankingrefunds/" + id);
    return response.data;
  } catch (error) {
    return [];
  }
}

async function getOpenBankingRefundByPaymentId(paymentId) {
  try {
    const response = await api.get(
      `api/openbankingrefunds/by-payment/${paymentId}`,
      { bypassInterceptor: true }
    );
    return response.data;
  } catch (error) {
    if (error?.response?.status === 404) {
      return null;
    }
    console.error("Error fetching open banking refund by payment id:", error);
    throw error;
  }
}

async function createOpenBankingRefund(
  paymentId,
  amount,
  reference,
  sortCode,
  accountNumber,
  accountHolderName,
  institutionId = null,
  callbackUrl = null) {
  try {
    const response = await api.post(
      `api/openbankingrefunds`,
      {
        paymentId,
        amount,
        reference,
        sortCode,
        accountHolderName,
        accountNumber,
        institutionId,
        callbackUrl,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
}

async function updateOpenBankingRefund(
  refundId,
  amount,
  reference,
  sortCode,
  accountNumber,
  accountHolderName) {
  try {
    const response = await api.put(
      `api/openbankingrefunds/${refundId}`,
      {
        amount,
        reference,
        sortCode,
        accountHolderName,
        accountNumber,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
}

async function cancelOpenBankingRefund(refundId) {
  try {
    const response = await api.post(`api/openbankingrefunds/${refundId}/cancel`);
    return response;
  } catch (error) {
    return error;
  }
}

async function createPaymentAuthorisation(refundId, institutionId, callbackUrl) {
  try {
    const response = await api.post(
      `api/openbankingrefunds/${refundId}/payment-authorisation`,
      {
        institutionId,
        callbackUrl,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
}

async function createCompletedOpenBankingRefund(
  paymentId,
  amount,
  reference) {
  try {
    const response = await api.post(
      `api/openbankingrefunds/completed`,
      {
        paymentId,
        amount,
        reference,
      }
    );
    return response;
  } catch (error) {
    return error;
  }
}

async function authoriseOpenBankingRefund(refundId, consent) {
  try {
    const response = await api.post(
      `api/openbankingrefunds/${refundId}/authorise`,
      {
        consent
      }
      , { bypassInterceptor: true }
    );

    if (!response || response.status >= 400) {
      throw new Error(`API request failed with status ${response?.status}`);
    }

    return response.data;
  } catch (error) {
    console.error("Error authorising Open Banking refund:", error);
    throw error;
  }
}

export {
  getOpenBankingRefund,
  getOpenBankingRefundByPaymentId,
  createOpenBankingRefund,
  updateOpenBankingRefund,
  cancelOpenBankingRefund,
  createPaymentAuthorisation,
  createCompletedOpenBankingRefund,
  authoriseOpenBankingRefund
};